import AvailabilitySettings from '@/admin/pages/settings/availability-settings';
import { availabilitiesQuery } from '@/admin/queries/availabilities';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_app/settings/availability')({
	loader: ({ context }) =>
		context.queryClient.ensureQueryData(availabilitiesQuery()),
	component: AvailabilitySettings,
});
